import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
	mode: "history",
	routes: [
		{
			path: "/",
			redirect: "/tickets"
		},
		{
			path: "/companies",
			name: "home",
			component: () => import("@/views/Companies.vue")
		},
		{
			path: "/moved-but-not-deleted-dossiers",
			name: "home",
			component: () => import("@/views/MovedButNotDeletedDossiers.vue")
		},
		{
			path: "/companies/new",
			component: () => import("@/views/CompanyNew.vue")
		},
		{
			path: "/companies/:id",
			redirect: "/companies/:id/info"
		},
		{
			path: "/companies/:id/edit",
			component: () => import("@/views/CompanyEdit.vue")
		},
		{
			path: "/companies/:id/info",
			component: () => import("@/views/CompanyInfo.vue")
		},
		{
			path: "/companies/:companyId/dossier/:dossierId",
			redirect: "/companies/:companyId/dossier/:dossierId/info",
		},
		{
			path: "/companies/:companyId/dossier/:dossierId/edit",
			component: () => import("@/views/DossierEdit.vue")
		},
		{
			path: "/companies/:companyId/dossier/:dossierId/info",
			component: () => import("@/views/DossierInfo.vue")
		},
		{
			path: "/companies/:companyId/dossier/:dossierId/scripts/new",
			component: ()=>import("@/views/ScriptEdit.vue")
		},
		{
			path: "/companies/:companyId/dossier/:dossierId/scripts/edit/:scriptId",
			component: ()=>import("@/views/ScriptEdit.vue")
		},
		{
			path: "/companies/:companyId/dossier/:dossierId/scripts/info/:scriptId",
			component: ()=>import("@/views/ScriptInfo.vue")
		},
		{
			path: "/companies/:companyId/dossier/:dossierId/calculated-fields/new",
			component: ()=>import("@/views/CalculatedFieldEdit.vue")
		},
		{
			path: "/companies/:companyId/dossier/:dossierId/calculated-fields/edit/:fieldId",
			component: ()=>import("@/views/CalculatedFieldEdit.vue")
		},
		{
			path: "/companies/:companyId/dossier/:dossierId/browse-extra-button/new",
			component: ()=>import("@/views/BrowseExtraButtonEdit.vue")
		},
		{
			path: "/companies/:companyId/dossier/:dossierId/browse-extra-button/edit/:buttonId",
			component: ()=>import("@/views/BrowseExtraButtonEdit.vue")
		},
		{
			path: "/companies/:companyId/dossier/:dossierId/auto-sale-row-setting/new",
			component: ()=>import("@/views/DossierAutoSaleRowSettingEdit.vue")
		},
		{
			path: "/companies/:companyId/dossier/:dossierId/auto-sale-row-setting/edit/:settingId",
			component: ()=>import("@/views/DossierAutoSaleRowSettingEdit.vue")
		},
		{
			path: "/modules",
			component: () => import("@/views/Modules.vue")
		},
		{
			path: "/modules/new",
			component: () => import( "@/views/ModuleNew.vue")
		},
		{
			path: "/modules/:id/edit",
			component: () => import("@/views/ModuleEdit.vue")
		},
		{
			path: "/tier",
			redirect: "/tier/0/"
		},
		{
			path: "/sales",
			component: () => import("@/views/TheSales.vue")
		},
		{
			path: "/metrics",
			component: () => import("@/views/TheMetrics.vue")
		},
		{
			path: "/tickets",
			component: () => import("@/views/TheTickets.vue"),
			children: [
				{path: ":id", component: () => import("@/views/TheTicket.vue")},
			]
		},
		{
			path: "/ticket/new",
			component: () => import("@/views/TicketCreate.vue")
		},
		{
			path: "/ticket",
			component: () => import("@/views/TheTickets.vue"),
			children: [
				{path: ":id", component: () => import("@/views/TheTicket.vue")},
			]
		},
		{
			path: "/ticket/",
			redirect: "/tickets"
		},
		{
			path: "/settings",
			component: () => import("@/views/TheSettings.vue")
		},
		{
			path: "/settings/extra-button/new",
			component: ()=>import("@/views/TheExtraButtonEdit.vue")
		},
		{
			path: "/settings/extra-button/:id",
			component: ()=>import("@/views/TheExtraButtonEdit.vue")
		},
		{
			path: "/logs",
			component: () => import("@/views/TheLogs.vue")
		},
		{
			path: "/motd",
			component: ()=>import("@/views/Motds.vue")
		},
		{
			path: "/motd/new",
			component: ()=>import("@/views/MotdEdit.vue")
		},
		{
			path: "/motd/edit/:id",
			component: ()=>import("@/views/MotdEdit.vue")
		},
		{
			path: "/roadmap",
			component: ()=>import("@/views/TheRoadmapItems.vue")
		},
		{
			path: "/roadmap/new",
			component: ()=>import("@/views/TheRoadmapItemEdit.vue")
		},
		{
			path: "/roadmap/edit/:id",
			component: ()=>import("@/views/TheRoadmapItemEdit.vue")
		},
		{
			path: "/roadmap/priorities/:appName",
			component: ()=>import("@/views/TheRoadmapEditPriorities.vue")
		},
		{
			path: "/referrals",
			component: ()=>import("@/views/TheReferrals.vue")
		},
		{
			path: "/discount-code",
			component: ()=>import("@/views/TheDiscountCodes.vue")
		},
		{
			path: "/read-list",
			component: ()=>import("@/views/ReadList.vue")
		},
		{
			path: "/discount-code/new",
			component: ()=>import("@/views/TheDiscountCodeEdit.vue")
		},
		{
			path: "/discount-code/edit/:id",
			component: ()=>import("@/views/TheDiscountCodeEdit.vue")
		},
		{
			path: "/subscriptions",
			component: ()=>import("@/views/TheSubscriptions.vue")
		},
		{
			path: "/scripts",
			component: ()=>import("@/views/FrontendScripts.vue")
		},
		{
			path: "/scripts/new",
			component: ()=>import("@/views/FrontendScriptEdit.vue")
		},
		{
			path: "/scripts/edit/:id",
			component: ()=>import("@/views/FrontendScriptEdit.vue")
		},
		{
			path: "/dangling-dbs/:id",
			component: ()=>import("@/views/DanglingDbs.vue")
		}
	]
});
